import React from 'react';
import { Text, Icon } from 'lmc-ui-library';
import { GuideItemProps } from './GuideItem.types';
import styles from './GuideItem.module.scss';

const GuideItem: React.FC<GuideItemProps> = ({ heading, description, url }) => {
  return (
    <div className={styles.wrapper}>
      <div>
        <Text weight="bold" className={styles.heading}>
          {heading}
        </Text>
        <Text className={styles.description}>{description}</Text>
      </div>
      <div>
        <a href={url} target="_blank" rel="noreferrer noopener" className={styles.link}>
          <Icon type="download" color="#607187" />
        </a>
      </div>
    </div>
  );
};

export default GuideItem;
